var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _vm.$store.state.auth.account.acc_id &&
      _vm.$route.meta.displayOrganization
        ? _c(
            "v-app-bar",
            {
              class: [
                "mx-2",
                { "mt-1": _vm.$route.params.prefix && this.offsetTop === 0 },
              ],
              staticStyle: {
                position: "fixed !important",
                transition: "none !important",
                "z-index": "6",
              },
              attrs: { flat: "", fixed: "", app: "", absolute: "" },
            },
            [
              _c(
                "v-alert",
                {
                  class: `${
                    _vm.$route.params.prefix
                      ? "inf-alert-purple fontTest--text"
                      : "inf-alert-grey fontDraw--text"
                  } ml-4 my-3 mr-3`,
                  attrs: {
                    height: 36,
                    width: "100%",
                    text: "",
                    outlined: "",
                    tile: "",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center ml-n1 mr-n1" },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: `${
                              _vm.$route.params.prefix
                                ? "grey-900"
                                : "fontDraw-mode"
                            }`,
                            size: "18",
                          },
                        },
                        [_vm._v("mdi-information")]
                      ),
                      _c(
                        "div",
                        { staticClass: "ml-3 description-alert-mode" },
                        [
                          _c(
                            "span",
                            {
                              class: `subtitle-2 font-weight-semibold ${
                                _vm.$route.params.prefix
                                  ? "grey-900"
                                  : "fontDraw-mode"
                              }--text`,
                            },
                            [
                              _vm._v(
                                "Estas navegando en un modo " +
                                  _vm._s(
                                    _vm.$route.params.prefix
                                      ? "prueba"
                                      : "producción"
                                  )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c("v-switch", {
                        staticClass: "mr-n1 ml-3 switch-modeTest",
                        attrs: {
                          color: `${
                            _vm.$route.params.prefix ? "grey-900" : ""
                          }`,
                          "hide-details": "",
                          ripple: false,
                          flat: "",
                          readonly: _vm.isReadonly,
                          "persistent-hint": "",
                        },
                        on: { click: _vm.test },
                        model: {
                          value: _vm.isTestMode,
                          callback: function ($$v) {
                            _vm.isTestMode = $$v
                          },
                          expression: "isTestMode",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("v-spacer"),
              _vm.$store.state.auth.account.acc_id
                ? _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-click": "",
                        "close-on-content-click": "",
                        "offset-y": "",
                        width: "300",
                        "nudge-bottom": 8,
                        left: "",
                        transition: "slide-y-transition",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "mr-4",
                                        attrs: { outlined: "", ripple: false },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require(`@/assets/account/account-choose-icon${
                                          _vm.$vuetify.theme.dark ? "-dark" : ""
                                        }.svg`),
                                        width: 16,
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "mx-2 text-truncate",
                                        staticStyle: { "max-width": "150px" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm.$store.state.auth.account.name
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-n1",
                                        attrs: { size: "18" },
                                      },
                                      [_vm._v("mdi-chevron-down")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2752091407
                      ),
                    },
                    [
                      _c(
                        "v-list",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "px-3",
                              attrs: {
                                "active-class": "green-500--text",
                                to: {
                                  name: "AccountBasic",
                                  params: _vm.currentParams,
                                },
                                ripple: false,
                              },
                            },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "body-2" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "grey-700",
                                        left: "",
                                        small: "",
                                      },
                                    },
                                    [_vm._v("mdi-cog")]
                                  ),
                                  _vm._v("Configuración"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            {
                              staticClass: "px-3",
                              attrs: { ripple: false },
                              on: { click: _vm.goTo },
                            },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "body-2" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "grey-700",
                                        left: "",
                                        small: "",
                                      },
                                    },
                                    [_vm._v("mdi-swap-horizontal")]
                                  ),
                                  _vm._v("Cambiar organización"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "730",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogMode,
            callback: function ($$v) {
              _vm.dialogMode = $$v
            },
            expression: "dialogMode",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            "Modo " +
                              _vm._s(
                                _vm.$route.params.prefix
                                  ? "producción"
                                  : "prueba"
                              )
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogMode = false),
                                        (_vm.confirm = "")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-mode.svg`),
                            width: 180,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-12" },
                        [
                          _c("span", { staticClass: "d-block body-1 pt-2" }, [
                            _vm._v(" Al confirmar, estarás cambiando de modo "),
                            _c(
                              "span",
                              { staticClass: "font-weight-semibold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$route.params.prefix
                                        ? "prueba"
                                        : "producción"
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" a modo "),
                            _c(
                              "span",
                              { staticClass: "font-weight-semibold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    !_vm.$route.params.prefix
                                      ? "prueba"
                                      : "producción"
                                  )
                                ),
                              ]
                            ),
                            _vm._v(
                              ". Por lo tanto, los documentos que generes en este modo se enviarán a " +
                                _vm._s(_vm.$t("generals.SUNAT")) +
                                ". Recuerda que podrás volver al modo actual en cualquier momento. "
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "d-block body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("“confirmar”"),
                              ]),
                              _vm._v(" para ir al "),
                              _c(
                                "span",
                                { staticClass: "font-weight-semibold" },
                                [
                                  _vm._v(
                                    " MODO " +
                                      _vm._s(
                                        !_vm.$route.params.prefix
                                          ? "PRUEBA"
                                          : "PRODUCCIÓN"
                                      ) +
                                      "."
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                _vm.confirm.toLowerCase() !== "confirmar"
                                  ? null
                                  : _vm.testMode(true)
                              },
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogMode = false),
                            (_vm.isTestMode = _vm.$route.params.prefix),
                            (_vm.confirm = "")
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.testMode(true)
                        },
                      },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }